<template><div><h1>VUX V2.2.1Rc.2 released</h1>
<h2><a href="/en/components/badge.html">Badge</a></h2>
<ul><li>[fix] Fix className:vux-badge-single not work for number #1223</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] Now next month's day can be clicked and will automatically switch to next month's view #1192</li>
<li>[fix] fix start-date and end-date not reactive #1219</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[enhance] Use document width as swiper width if initial width is 0 #1188</li>
<li>[fix] Fix initial index > 0 not works</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.2 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.2-101.vue?aa741626